<template>
  <div style="display: flex; align-items: center;justify-content: center;">
    <div style="padding: 20px 40px; width: 100%;">
      <el-tabs>
        <el-tab-pane label="微信支付配置" >
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
            <div style="margin: 20px;">
              <el-form-item label="AppID" prop="nonull">
                <el-input v-model="ruleForm.appid" placeholder="请输入AppID"></el-input>
              </el-form-item>
              <el-form-item label="AppSecret" prop="nonull">
                <el-input v-model="ruleForm.appsecret" placeholder="请输入AppSecret"></el-input>
              </el-form-item>
              <el-form-item label="Token" prop="nonull">
                <el-input v-model="ruleForm.token" placeholder="请输入Token"></el-input>
              </el-form-item>
              <el-form-item label="商户号" prop="nonull">
                <el-input v-model="ruleForm.mchid" placeholder="请输入商户号"></el-input>
              </el-form-item>
              <el-form-item label="商户Key" prop="nonull">
                <el-input v-model="ruleForm.appkey" placeholder="请输入商户Key"></el-input>
              </el-form-item>
            </div>
            <div class="savebasepanel">
              <el-button type="primary" @click="savewx('ruleForm')">保存信息</el-button>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'SMSSet',
    data () {
      var validateNull = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不允许为空'));
        } else {
          callback();
        }
      }
      return {
        ruleForm: {
          appid: '',
          appsecret: '',
          token: '',
          mchid: '',
          appkey: ''
        },
        rules: {
          nonull: [
            { validator: validateNull, trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      that = this
      that.$options.methods.loadwx()
    },
    methods: {
      loadwx () {
        var qstr = 'accountid =' + parseInt(localStorage.getItem('accountid'))
        that.$http({
          url: 'https://api.sqnetsoft.cn/system/qbwx',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            sorinfo: {String: ' order by id desc', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log('已成功短信配置数据')
              var smsdata = JSON.parse(res.data.data)
              that.ruleForm.appid = smsdata[0].appid.String
              that.ruleForm.appsecret = smsdata[0].appsecret.String
              that.ruleForm.token = smsdata[0].token.String
              that.ruleForm.mchid = smsdata[0].mchid.String
              that.ruleForm.appkey = smsdata[0].appkey.String
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      savewx(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var adata = {
              accountid: parseInt(localStorage.getItem('accountid')),
              appid: {String:that.ruleForm.appid.toString(),Valid:true},
              appsecret: {String:that.ruleForm.appsecret.toString(),Valid:true},
              token: {String:that.ruleForm.token.toString(),Valid:true},
              mchid: {String:that.ruleForm.mchid.toString(),Valid:true},
              appkey: {String:that.ruleForm.appkey.toString(),Valid:true}
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/system/aaubwx',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '更新成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/system/PaySet.vue